import { useJsApiLoader } from '@react-google-maps/api';
import React from 'react';

const withGoogleMaps = <T extends {}>(WrappedComponent: React.ComponentType<T>, googleMapsApiKey: string) =>
  function (props: T): React.ReactElement {
    const { isLoaded } = useJsApiLoader({
      id: 'google-map-script',
      googleMapsApiKey,
    });
    if (!isLoaded) {
      return <p>Loading</p>;
    }
    return <WrappedComponent {...props} />;
  };

export default withGoogleMaps;
